export const izjava_nagrade_rezultati = {
    templateId: 38.2,
    category: 4,
    templateTitle: 'Izjava radnika o isplaćenim nagradama kod drugog/ih i/ili bivšeg/ih poslodavaca',
    templateDescription: `<p>Radnik je obvezan poslodavcu koji namjerava isplatiti nagradu, prije isplate podnijeti pisanu izjavu u kojoj navodi je li kod drugog/ih i/ili bivšeg/ih poslodavaca ostvario isplatu nagrade za određeno razdoblje i u kojem iznosu. </p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubrajaju se i nagrade za radne rezultate i drugi oblici dodatnog nagrađivanja radnika (dodatna plaća, dodatak uz mjesečnu plaću i sl.) te su iste neoporezive ako ne prelaze ukupan iznos do 7.500,00 kn godišnje, po radniku.</p>
    <p>Primjer odluke kojom se određuje nagrada za radne rezultate i druge oblike dodatnog nagrađivanja radnika možete vidjeti <a class="local-link" href="/contract?template=38.1">ovdje</a>.
    <p>Ako se nagrada za radne rezultate i drugi oblici dodatnog nagrađivanja isplaćuju radniku:</p>
    <li> koji radi istovremeno kod dva ili više poslodavaca u poreznom razdoblju za koje se primici isplaćuju i/ili</li>
    <li> koji je tijekom poreznog razdoblja imao zasnovan radni odnos kod najmanje dva poslodavaca, ali ne istovremeno,</li>
    <br>
    <p>radnik je obvezan prije isplate takvih primitaka, poslodavcu koji namjerava isplatiti nagradu, podnijeti pisanu izjavu u kojoj navodi je li kod bilo kojeg drugog i/ili bivšeg poslodavca ostvario isplatu tih primitaka za određeno razdoblje i u kojem iznosu.</p>
    <p>U slučaju da su nagrade za radne rezultate i drugi oblici dodatnog nagrađivanja već dijelom isplaćeni za isto razdoblje kod drugog/ih i/ili bivšeg/ih poslodavaca, neoporezivo se može isplatiti samo razlika do propisanog iznosa.</p>
    <p><strong>Radnik nije obvezan podnijeti pisanu izjavu ukoliko poslodavac ima uvid u podatke putem sustava ePorezna koji se odnose na isplaćene neoporezive primitke koje radnik može ostvariti od više poslodavaca i isplatitelja plaće do određenoga godišnjeg iznosa u poreznom razdoblju.</strong></p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
        inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
      
    headline: "upućuje sljedeću",
    title: "IZJAVU",
  
    noArticleNumbers: true,

    articles: [
      {
        title: "",
        dummy: true, 
        mandatory: true,
        statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: "text", content: "kojom ja, gore navedeni, s danom davanja ove Izjave, Poslodavcu" },
            { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
          { type: "text", content: "," },
          { type: "input",  required: true, placeholder: "Unesite sjedište poslodavca" },
          { type: "text", content: ", OIB:" },
          { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
            { type: "text", content: "izjavljujem sljedeće:" },
          ],
          value: "",
        },
      ]
    },
    {
      title: '',
      mandatory: true,
      dummy: true, 
      statements: [
          {
              type: 'choice',
              mandatory: true,
              editable: false,
              choices: [
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, nisam primio isplate nagrada za radne rezultate i drugih oblika dodatnog nagrađivanja radnika kod bivšeg/bivših poslodavaca odnosno kod drugog/drugih poslodavaca." },
                     ]
                  },
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, od bivšeg/bivših poslodavaca primio sam isplate nagrada za radne rezultate i drugih oblika dodatnog nagrađivanja radnika u ukupnom iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: "." },
                     ]
                  },
                  {
                    parts: [
                      { type: "text", content: "tijekom" },
                      { type: "input",  required: true, placeholder: "Unesite godinu." },
                      { type: "text", content: "godine, od drugog/drugih poslodavaca, kod kojeg/kojih sam trenutno zaposlen, primio sam isplate nagrada za radne rezultate i drugih oblika dodatnog nagrađivanja radnika u ukupnom iznosu od" },
                      { type: "input",  required: true, placeholder: "Unesite iznos." },
                      { type: "text", content: "." },
                   ]
                },
                  {
                      parts: [
                        { type: "text", content: "tijekom" },
                        { type: "input",  required: true, placeholder: "Unesite godinu." },
                        { type: "text", content: "godine, od bivšeg/bivših poslodavaca primio sam isplate nagrada za radne rezultate i drugih oblika dodatnog nagrađivanja radnika u ukupnom iznosu od" },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: ", a od drugog/drugih poslodavaca, kod kojeg/kojih sam trenutno zaposlen, primio sam isplate nagrada za radne rezultate i drugih oblika dodatnog nagrađivanja radnika u ukupnom iznosu od " },
                        { type: "input",  required: true, placeholder: "Unesite iznos." },
                        { type: "text", content: "." },
                      ]
                  }],
              value: '',
          }
      ]
  },
  {
    title: '',
    mandatory: true,
    dummy: true, 
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Osim prethodno navedenog, po osnovi nagrade za radne rezultate i drugih oblika dodatnog nagrađivanja radnika, tijekom prethodno naznačene godine nisam ostvario nikakve druge primitke.',
            value: '',
        }],
},


      {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
          {
            type: "input",
            mandatory: true,
            parts: [
              {
                type: "text",
                content: "U"
              },
              {
                type: "input",
                value: "",
                placeholder: "Upišite mjesto.",
                required: true,
              },
              {
                type: "text",
                content: ", dana"
              },
              {
                type: "date",
                value: new Date(),
                required: true
              },
              {
                type: "text",
                content: "godine."
              }
            ]
          },
        ]
      },
      {
        mandatory: true,
        static: true,
        type: 3,  // signatures   
        statements: [],
      },
      {
        static: true,
        mandatory: true,
        editable: true,
        type: 4, 
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: "\r\nPoslodavac svojim potpisom potvrđuje primitak Izjave dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
            },
          ],
        },
    ],
    };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/38.2_izjava_nagrade_rezultati.ts